module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/readable-stream/transform.js
// module id = ../../../../readable-stream/transform.js
// module chunks = common